const { StyleSheet } = require("aphrodite");

const pageStyles = StyleSheet.create({
  container: {
    maxWidth: '1200px',
    marginLeft: '50px',
    marginRight: '50px',
  },
});

export default pageStyles;
